<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import "lodash";
import { BaseAtom } from "components/cards/atoms";
export let container;
export let animationId;
</script>

<style></style>

<BaseAtom _isotope="CustomAnimation" {...container}>
  <div>Custom Animation: {animationId}</div>
</BaseAtom>
